import React, { useCallback, useMemo } from 'react';
import List from '@mui/material/List';
import { IGroup } from '@api/Groups.api';
import GroupItemComponent from './Group-item.component';
import { IProps as IMainProps } from './IProps';
import { settingsMap } from './settings-map';

interface IProps
    extends Omit<
        IMainProps,
        'lang' | 'demoModeError' | 'serverError' | 'onShareClick' | 'onCancel'
    > {}

const Component: React.FC<IProps> = ({
    groups,
    devices,
    selectedDevices,
    visibleList,
    settingsList,
    settingDeviceImei,
    onDeviceSelect,
    onDeviceClick,
    onGroupClick,
}: IProps) => {
    const settingsMap: settingsMap = useMemo(
        () =>
            settingsList.reduce(
                (acc, item) => ({
                    ...acc,
                    [item.imei]: item.status && !item.status.error,
                }),
                {},
            ),
        [settingsList],
    );
//ВОТ ЗДЕСЬ ГРУППИРУЕТСЯ
    const groupFilter = useCallback(
        (group: IGroup) => {
            const { id } = group;
            const len = devices.filter(
                (device) =>
                    device.groupId === id &&
                    device.imei !== settingDeviceImei 
            ).length;
            return len !== 0;
            
        },
        [devices, settingDeviceImei, settingsMap],
    );

    const getGroupItem = useCallback(
        (group: IGroup) => {
            const { id, name } = group;
            const visible = visibleList[id];
            let deviceList = devices.filter(
                (device) =>
                    device.groupId === id &&
                    device.imei !== settingDeviceImei 
            );

            
            return (
                <GroupItemComponent
                    name={name}
                    devices={deviceList}
                    key={id}
                    id={id}
                    visible={visible}
                    settingsList={settingsList}
                    selectedDevices={selectedDevices}
                    onGroupClick={onGroupClick}
                    onDeviceClick={onDeviceClick}
                    onDeviceSelect={onDeviceSelect}
                />
            );
        },
        [
            visibleList,
            devices,
            settingDeviceImei,
            settingsMap,
            settingsList,
            selectedDevices,
            onGroupClick,
            onDeviceClick,
            onDeviceSelect,
        ],
    );
    return (
        <List className="groups__list_modal">
            {groups.filter(groupFilter).map(getGroupItem)}
        </List>
    );
};

const ListComponent = React.memo(Component);

export default ListComponent;
